import { configureStore } from '@reduxjs/toolkit'
import userSlice from '../reducers/user/userSlice';
import campaignSlice from '../reducers/campaign/campaignSlice';
import entitySlice from '../reducers/entity/entitySlice';
import expariencesSlice from '../reducers/expariences/expariencesSlice';
import myDesignsSlice from '../reducers/myDesigns/myDesignsSlice';
import configuratorSlice from '../reducers/configurator/configuratorSlice';

export const store = configureStore({
  reducer: {
    campaign: campaignSlice,
    user: userSlice,
    myDesigns: myDesignsSlice,
    myExpariences: expariencesSlice,
    entity: entitySlice,
    configurator: configuratorSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})
